module.exports = __webpack_public_path__ + "static/media/2.Openwell pumps (0.5 - 5 Hp).61303067.jpg";